// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__3TEoV","slider":"Switch_slider__oO18O","round":"Switch_round__2eTLb"};